import React, { useCallback } from "react";
import { useFormState } from "react-final-form";
import { useDispatch } from "react-redux";
import {
  SaveButton,
  useRedirect,
  useNotify,
  fetchStart,
  fetchEnd,
} from "react-admin";
import Parse from "parse";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const UserEditButton = (props) => {
  const redirectTo = useRedirect();
  const dispatch = useDispatch();
  const notify = useNotify();
  const formState = useFormState();
  const handleClick = useCallback(async () => {
    if (!formState.valid) {
      return;
    }

    console.log("The values from client form---->", formState.values);

    try {
      dispatch(fetchStart());
      if (
        formState.values.profileImage !== null &&
        formState.values.hasOwnProperty("profileImage")
      ) {
        const ParseFile = formState.values.profileImage.hasOwnProperty("_url")
          ? null
          : await toBase64(formState.values.profileImage.rawFile);
        console.log("ParseFile", ParseFile);
        const params = {
          id: formState.values.id,
          data: formState.values,
          profileImage: ParseFile,
        };
        const UpdatedUser = await Parse.Cloud.run("UpdateUser", {
          params: JSON.stringify(params),
        });

        if (UpdatedUser) {
          notify("User Updated");
          dispatch(fetchEnd());
          redirectTo("/User");
        } else {
          notify("User Updated");
          dispatch(fetchEnd());
          redirectTo("/User");
        }
      } else {
        const params = {
          id: formState.values.id,
          data: formState.values,
        };

        const UpdatedUser = await Parse.Cloud.run("UpdateUser", {
          params: JSON.stringify(params),
        });

        if (UpdatedUser) {
          notify("User Updated");
          dispatch(fetchEnd());
          redirectTo("/User");
        } else {
          notify("User Updated");
          dispatch(fetchEnd());
          redirectTo("/User");
        }
      }
    } catch (e) {
      notify(e.message);
      console.log("tHE ERRIR------->", e);
    } finally {
      dispatch(fetchEnd());
    }
  }, [
    formState.valid,
    formState.values,
    notify,
    redirectTo,
    dispatch,
  ]);

  return (
    <div>
      {" "}
      <SaveButton {...props} handleSubmitWithRedirect={handleClick} />
    </div>
  );
};

export default UserEditButton;
